import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MuiHeader from "../../components/MuiHeader";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AodIcon from "@mui/icons-material/Aod";
import UndoIcon from "@mui/icons-material/Undo";
import Modal from "@mui/material/Modal";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import TextField from "@mui/material/TextField";
import AddIcon from "@mui/icons-material/Add";
import api from "../../api/api";
import { red, blue, green, purple } from "@mui/material/colors";
// MUI
import {
  Avatar,
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  Card,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
  TableHead,
  TableCell,
  Table,
  TableRow,
  TableBody,
  Paper,
} from "@mui/material";
import { usertype_change } from "./CommonQuizTopic.Slice";
// import {
//   getCommonQuizTopicThunk,
//   createCommonQuizTopicThunk,
//   updateCommonQuizTopicThunk,
//   deleteCommonQuizTopicThunk,
// } from "./CommonQuizTopic.Thunk";
import {
  getCommonQuizTopicThunk,
  createCommonQuizTopicThunk,
  updateCommonQuizTopicThunk,
  deleteCommonQuizTopicThunk,
} from "./CommonQuizTopic.Thunk";

const TeacherCategoryPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // -------------- Card-item vertical menu ---------------
  const ITEM_HEIGHT = 48;
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [recordId, setRecordId] = useState("");
  const [selectedSkillsetId, setSelectedSkillsetId] = useState("");
  const [selectedSkillsetName, setSelectedSkillsetName] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const openVertMenu = Boolean(anchorEl);
  const handleVertMenuClick = (event, _id, topicId, topicName, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedIndex(index);
    setRecordId(_id);
    setSelectedSkillsetId(topicId);
    setSelectedSkillsetName(topicName);
  };
  const handleVertMenuClose = () => {
    setAnchorEl(null);
  };
  // ---------------------------------------------

  // ------------ Grid gallery view -----------
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // ---------------------------------------------

  // ---------------- navigate to skillset manager -------------
  const navigate_to = () => {
    navigate("/commonmonthlyquiz");
  };
  // ------------------------------------------------------------

  // --------- options for dropdowns ---------
  const usertype_select_option_list = [
    { value: "fellow", text: "Educator" },
    { value: "school", text: "School" },
    { value: "anganwadi", text: "Anganwadi" },
    { value: "cci", text: "CCI" },
  ];
  const language_select_option_list = [
    { value: "od", text: "ଓଡିଆ" },
    { value: "en", text: "English" },
  ];
  const validity_select_option_list = [
    { value: "limited", text: "Limited" },
    { value: "unlimited", text: "Unlimited" },
  ];
  const [language, setLanguage] = useState("od");
  // ------------ dropdowns on change ----------------
  const usertype_select_onchange = (event) => {
    dispatch(usertype_change(event.target.value));
  };
  const language_select_onchange = (e) => {
    setLanguage(e.target.value);
  };

  const data = useSelector((state) => state.CommonQuizTopicSlice.topic);

  // ------------ Load data & skill ----------------

  const topicId = useSelector((state) => state.CommonQuizTopicSlice.topicId);

  const topicName = useSelector(
    (state) => state.CommonQuizTopicSlice.topicName
  );
  // const [validityType, setValidityType] = useState("");
  // //console.log("validityType-->", validityType);

  const usertype = useSelector((state) => state.CommonQuizTopicSlice.usertype);
  const validityType = useSelector(
    (state) => state.CommonQuizTopicSlice.validityType
  );

  const disable_content_button = useSelector(
    (state) => state.CommonQuizTopicSlice.disable_content_button
  );

  useEffect(() => {
    const load_data = () => {
      const params = { topicId, topicName, usertype };
      dispatch(getCommonQuizTopicThunk(params));
    };
    load_data();
  }, [dispatch, topicId, topicName, usertype]);

  // -----------------------------------------------

  // For State Declaration
  const [show, setShow] = useState(false);

  //On Modal close and open

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showUpdate, setShowUpdate] = useState(false);

  const [changetopicName, setChangetopicName] = useState("");
  const handleChangetopicName = (event) => {
    setChangetopicName(event.target.value);
  };
  const [changevalidity, setChangevalidity] = useState("");
  const handleChangevalidity = (event) => {
    const newValidityValue = parseInt(event.target.value);
    setChangevalidity(newValidityValue);
    setUpdateData((prevData) => ({
      ...prevData,
      validity: newValidityValue,
    }));
  };
  const [changevaliditytype, setChangevaliditytype] = useState("");
  const handleChangevaliditytype = (event) => {
    setChangevaliditytype(event.target.value);
  };

  // ----------- create, update delete button click ----------
  const [isLoading, setIsLoading] = useState(false);
  const dataa = {
    topicId: new Date().getTime(),
    topicName: changetopicName,
    validity: changevalidity,
    language: "od",
    module: "teacher",
    usertype: usertype,
    validityType: changevaliditytype,
    // category: categoryId,
  };
  // const handleSave = () => {
  //   setShow(false);
  //   setIsLoading(true);
  //   toast.success("Changes made successfully");
  //   dispatch(createCommonQuizTopicThunk(dataa)).then((res) => {
  //     const params = { topicId, topicName, usertype };
  //     dispatch(getCommonQuizTopicThunk(params));
  //   });
  // };

  const handleSave = async () => {
    setShow(false);
    setIsLoading(true);

    try {
      const res = await dispatch(createCommonQuizTopicThunk(dataa));

      if (res.error) {
        throw res.error;
      }

      toast.success("Changes made successfully", {
        style: {
          backgroundColor: "green",
          color: "white",
          borderRadius: "30px",
        },
      });

      const params = { topicId, topicName, usertype };
      await dispatch(getCommonQuizTopicThunk(params));
    } catch (err) {
      if (err.response) {
        if (err.response.status === 500) {
          toast.error("Internal Server Error. Please try again later.", {
            style: {
              backgroundColor: "red",
              color: "white",
              borderRadius: "30px",
            },
          });
        } else if (err.response.status === 504) {
          toast.error("Gateway Timeout. Please try again later.", {
            style: {
              backgroundColor: "red",
              color: "white",
              borderRadius: "30px",
            },
          });
        } else {
          toast.error(
            `Error: ${err.response.status}. Please try again later.`,
            {
              style: {
                backgroundColor: "red",
                color: "white",
                borderRadius: "30px",
              },
            }
          );
        }
      } else {
        toast.error("An unexpected error occurred. Please try again later.", {
          style: {
            backgroundColor: "red",
            color: "white",
            borderRadius: "30px",
          },
        });
        console.error(`The error in getting data: ${err}`);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const [updateData, setUpdateData] = useState({
    // _id: "",
    questionId: new Date().getTime(),
    topicId: topicId,
    topicName: "",
    validity: 0,
    validityType: "",
    // duration: "",
    usertype: usertype,
    language: "od",
    module: "teacher",
  });
  //console.log("updateData-->", updateData);

  const [updateExtra, setUpdateExtra] = useState([]);
  const handleShowUpdate = (eachskill) => {
    setUpdateExtra(eachskill);
    setUpdateData({
      // _id: eachskill._id,
      topicId: eachskill.topicId,
      questionId: eachskill.questionId,
      topicName: eachskill.topicName,
      validity: parseInt(eachskill.validity),
      validityType: eachskill.validityType,
      // duration: eachskill.duration,
      //   usertype: usertype,
      // language: "od",
    });
    setShowUpdate(true);
  };

  // const handleUpdateChanges = () => {
  //   // //console.log("updateExtra-->", updateExtra);
  //   api.put(`updateMasterTtlQuizTopic`, updateData).then(
  //     (response) => {
  //       const params = { topicId, topicName, usertype };
  //       dispatch(getCommonQuizTopicThunk(params));
  //       toast.success("Changes made successfully");
  //       //  setResult(response.data);
  //       // //console.log("response.data-->", response.data)
  //       // if (response.data.status === "success") {
  //       //   toast.success("Changes made successfully");
  //       //   const params = { topicId, topicName, usertype };
  //       //   dispatch(getCommonQuizTopicThunk(params));
  //       // }
  //     },
  //     (err) => {
  //       //console.log(err);
  //       toast.error("Enter a valid Topic");
  //     }
  //   );
  //   setShowUpdate(false);
  // };

  const handleUpdateChanges = async () => {
    setShowUpdate(false);
    setIsLoading(true);

    try {
      const response = await api.put(`updateMasterTtlQuizTopic`, updateData);

      if (response.status === 200) {
        const params = { topicId, topicName, usertype };
        await dispatch(getCommonQuizTopicThunk(params));
        toast.success("Changes made successfully", {
          style: {
            backgroundColor: "green",
            color: "white",
            borderRadius: "30px",
          },
        });
      } else {
        throw new Error(`Unexpected response status: ${response.status}`);
      }
    } catch (err) {
      if (err.response) {
        if (err.response.status === 500) {
          toast.error("Internal Server Error. Please try again later.", {
            style: {
              backgroundColor: "red",
              color: "white",
              borderRadius: "30px",
            },
          });
        } else if (err.response.status === 504) {
          toast.error("Gateway Timeout. Please try again later.", {
            style: {
              backgroundColor: "red",
              color: "white",
              borderRadius: "30px",
            },
          });
        } else {
          toast.error(
            `Error: ${err.response.status}. Please try again later.`,
            {
              style: {
                backgroundColor: "red",
                color: "white",
                borderRadius: "30px",
              },
            }
          );
        }
      } else {
        toast.error("An unexpected error occurred. Please try again later.", {
          style: {
            backgroundColor: "red",
            color: "white",
            borderRadius: "30px",
          },
        });
        console.error(`The error in updating data: ${err}`);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseUpdate = () => {
    setShowUpdate(false);
  };

  // const delete_content_button_click = (questionId) => {
  //   //console.log("topicId-->", topicId);
  //   handleVertMenuClose();
  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "Once deleted, you will not be able to recover this record!",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#d33",
  //     confirmButtonText: "Yes, delete it!",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       dispatch(deleteCommonQuizTopicThunk(questionId)).then(() => {
  //         const params = { usertype };
  //         dispatch(getCommonQuizTopicThunk(params));
  //         toast.success("Changes made successfully");
  //       });
  //     }
  //   });
  // };
  const delete_content_button_click = async (questionId) => {
    handleVertMenuClose();

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      setIsLoading(true);

      try {
        const response = await dispatch(deleteCommonQuizTopicThunk(questionId));

        if (response.error) {
          throw response.error;
        }

        const params = { usertype };
        await dispatch(getCommonQuizTopicThunk(params));

        toast.success("Changes made successfully", {
          style: {
            backgroundColor: "green",
            color: "white",
            borderRadius: "30px",
          },
        });
      } catch (err) {
        if (err.response) {
          if (err.response.status === 500) {
            toast.error("Internal Server Error. Please try again later.", {
              style: {
                backgroundColor: "red",
                color: "white",
                borderRadius: "30px",
              },
            });
          } else if (err.response.status === 504) {
            toast.error("Gateway Timeout. Please try again later.", {
              style: {
                backgroundColor: "red",
                color: "white",
                borderRadius: "30px",
              },
            });
          } else {
            toast.error(
              `Error: ${err.response.status}. Please try again later.`,
              {
                style: {
                  backgroundColor: "red",
                  color: "white",
                  borderRadius: "30px",
                },
              }
            );
          }
        } else {
          toast.error("An unexpected error occurred. Please try again later.", {
            style: {
              backgroundColor: "red",
              color: "white",
              borderRadius: "30px",
            },
          });
          console.error(`The error in deleting data: ${err}`);
        }
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      <div>
        <MuiHeader header="Common Monthly Quiz" />

        <FormControl sx={{ m: 1, minWidth: 120, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">Language</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={language}
            label="Language"
            onChange={language_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {language_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1, minWidth: 120, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">Usertype</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={usertype}
            label="Language"
            onChange={usertype_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {usertype_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          onClick={navigate_to}
          variant="outlined"
          sx={{
            minWidth: 80,
            alignItem: "right",
            backgroundColor: "blue",
            color: "black",
          }}
          size="small"
        >
          <UndoIcon style={{ color: "orange" }}></UndoIcon>
          Back
        </Button>
      </div>

      {/* Show List */}
      <div>
        <div>
          <Button
            onClick={handleShow}
            variant="contained"
            sx={{ marginTop: 3, float: "left" }}
            // disabled={disable_content_button}
          >
            create new topic
            {/* <AddIcon /> */}
          </Button>
          <br />
          <br />
          <br />

          <Modal
            open={show}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <br />
              <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2} style={{ marginTop: 12 }}>
                    <Grid style={{ width: "125px" }}>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginTop: "14px" }}
                      >
                        validity type
                      </InputLabel>
                      <Select
                        id="outlined-basic"
                        style={{ width: "210px", marginLeft: "18px" }}
                        label="validity type"
                        variant="outlined"
                        onChange={handleChangevaliditytype}
                      >
                        <MenuItem value="">None</MenuItem>
                        <MenuItem value="limited">Limited</MenuItem>
                        <MenuItem value="unlimited">Unlimited</MenuItem>
                      </Select>
                    </Grid>

                    <Grid item xs={9} md={9}>
                      <TextField
                        id="outlined-basic"
                        label="topic"
                        variant="outlined"
                        onChange={handleChangetopicName}
                      />
                    </Grid>

                    {/* {validityType === "limited" ? ( */}
                    <>
                      {changevaliditytype !== "" &&
                        changevaliditytype !== "unlimited" && (
                          <Grid item xs={9} md={9}>
                            <TextField
                              id="outlined-basic"
                              label="validity"
                              variant="outlined"
                              inputProps={{ type: "number", min: 0 }}
                              onChange={handleChangevalidity}
                            />
                          </Grid>
                        )}
                    </>
                  </Grid>
                </Box>
              </FormControl>
              <Button
                variant="outlined"
                style={{ marginLeft: 12 }}
                onClick={handleClose}
              >
                Close
              </Button>
              <Button variant="contained" onClick={handleSave}>
                Save
              </Button>
            </Box>
          </Modal>
        </div>
        <br />
        {data && data.length > 0 ? (
          <Paper style={{ width: 700 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: "60px" }}> Order </TableCell>
                  <TableCell style={{ width: "210px", paddingLeft: "30px" }}>
                    Topic
                  </TableCell>
                  <TableCell style={{ width: "170px", paddingLeft: "80px" }}>
                    Validity Type
                  </TableCell>
                  <TableCell style={{ width: "120px", paddingLeft: "80px" }}>
                    Validity
                  </TableCell>
                  <TableCell style={{ paddingLeft: "120px" }}>Action</TableCell>
                </TableRow>
              </TableHead>

              {/* <table style={{ border: "1px solid blue" }}> */}

              {data.map((eachskill, index) => (
                <TableBody key={index}>
                  <TableRow>
                    <TableCell style={{ width: "100px" }}>
                      {index + 1}
                    </TableCell>
                    <TableCell style={{ width: "180px", paddingLeft: "30px" }}>
                      {eachskill.topicName}
                    </TableCell>{" "}
                    <TableCell style={{ width: "100px", paddingLeft: "80px" }}>
                      {eachskill.validityType}
                    </TableCell>{" "}
                    <TableCell style={{ width: "100px", paddingLeft: "95px" }}>
                      {" "}
                      {eachskill.validity ? eachskill.validity : "NA"}
                    </TableCell>
                    <TableCell
                      style={{
                        width: -20,
                        paddingLeft: "-130px",
                        marginLeft: "-120px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <Button
                          style={{ marginLeft: 65 }}
                          onClick={() => handleShowUpdate(eachskill)}
                        >
                          <EditIcon style={{ color: "blue" }}></EditIcon>
                        </Button>
                        <Button
                          onClick={() => delete_content_button_click(eachskill)}
                        >
                          <DeleteIcon style={{ color: "red" }}></DeleteIcon>
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              ))}
            </Table>
          </Paper>
        ) : null}

        <Modal
          open={showUpdate}
          onClose={handleCloseUpdate}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
              <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2} style={{ marginTop: 1 }}>
                  <Grid item xs={6} md={6}>
                    <Select
                      id="outlined-basic"
                      style={{ width: "140px" }}
                      label="validity type"
                      variant="outlined"
                      value={updateData.validityType}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          validityType: e.target.value,
                        })
                      }
                    >
                      <MenuItem value="">None</MenuItem>
                      <MenuItem value="limited">Limited</MenuItem>
                      <MenuItem value="unlimited">Unlimited</MenuItem>
                    </Select>
                  </Grid>
                  {/* <Grid item xs={6} md={6}>
                  <TextField
                      id="outlined-basic"
                      label="Validitytype"
                      variant="outlined"
                      value={updateData.validityType}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          validityType: e.target.value,
                        })
                      }
                    />
                  </Grid> */}
                  <Grid item xs={6} md={6}>
                    <TextField
                      id="outlined-basic"
                      label="Topic"
                      variant="outlined"
                      value={updateData.topicName}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          topicName: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <TextField
                      id="outlined-basic"
                      label="Validity"
                      variant="outlined"
                      value={updateData.validity}
                      inputProps={{ type: "number", min: 0 }}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          validity: parseInt(e.target.value),
                        })
                      }
                    />
                  </Grid>
                </Grid>
              </Box>
            </FormControl>

            <Button
              variant="outlined"
              style={{ marginLeft: 12 }}
              onClick={handleCloseUpdate}
            >
              Close
            </Button>
            <Button variant="contained" onClick={handleUpdateChanges}>
              Update
            </Button>
          </Box>
        </Modal>
      </div>
      {/* Toaster */}
      <ToastContainer />
    </>
  );
};

export default TeacherCategoryPage;
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

// <div>
// <Button
//  onClick={create_content_button_click}
//  variant="contained">
//   <AddIcon />
//   Create New
// </Button>
// <Box sx={{ flexGrow: 1 }}>
//   <Grid container spacing={3}>
//     {data.map((eachskill, index) => (
//       <Grid item xs={12} sm={isSmallScreen ? 12 : 6} md={4} key={index}>
//         <Card sx={{ maxWidth: 345 }}>
//           <CardHeader
//             avatar={
//               <Avatar sx={{ bgcolor: purple[500] }}>
//                 <AodIcon />
//               </Avatar>
//             }
//             action={
//               <>
//                 <IconButton
//                   id={index + 1.1}
//                   onClick={(e) =>
//                     handleVertMenuClick(
//                       e,
//                       eachskill._id,
//                       eachskill.topicId,
//                       eachskill.topicName,
//                       eachskill.validity,
//                       index
//                     )
//                   }
//                   aria-controls={openVertMenu ? { index } : undefined}
//                   aria-expanded={openVertMenu ? "true" : undefined}
//                   aria-haspopup="true">
//                   <MoreVertIcon />
//                 </IconButton>
//               </>
//             }
//             title={
//               <div style={{ cursor: "pointer" , wordBreak: "break-all"}}>
//                 {eachskill.topicName}
//               </div>
//             }

//           />
//         </Card>
//       </Grid>
//     ))}
//     <Menu
//       id={selectedIndex}
//       anchorEl={anchorEl}
//       open={openVertMenu}
//       onClose={handleVertMenuClose}
//       MenuListProps={{
//         "aria-labelledby": "vert-button",
//       }}
//       PaperProps={{
//         style: {
//           maxHeight: ITEM_HEIGHT * 4.5,
//           width: "20ch",
//         },
//       }}>
//       <MenuItem
//         onClick={() =>
//           update_content_button_click(recordId, selectedSkillsetName)
//         }
//         >
//         Edit
//       </MenuItem>
//       <MenuItem
//        onClick={() => delete_content_button_click(recordId)}
//       >
//         Delete
//       </MenuItem>
//     </Menu>
//   </Grid>
// </Box>
// </div>
